<template>
  <v-card>
    <delete-dialog
      @success="deleteInvoice"
      :confirm-loading="deleteConfirmLoading"
      @closeDialog="cancelDelete"
      :dialog="delete_dialog"
      title="Invoice"
    ></delete-dialog>
    <v-row>
      <v-col sm="5" md="4" lg="4" cols="12 pl-10">
        <router-link class="profile-link" :exact="true" :to="{ name: 'AddTutorEarning' }">
          <v-btn color="#6A158E" dark v-if="perms.tutor_earn_add">Create Earning</v-btn>
        </router-link>
      </v-col>
      <v-col
        sm="5"
        md="4"
        lg="4"
        offset-lg="4"
        offset-md="4"
        offset-sm="2"
        cols="12 pl-10 pr-10"
      >
        <AccountMonthlySearch @changeYear="searchByYear" @change="searchByMonth" />
      </v-col>
    </v-row>
    <v-data-table :page.sync="page" :items="items" :headers="headers" hide-default-footer>
      <template v-slot:item.user.name="{ item }">
        <span class="table-complete-name">{{ item.name }}</span>
      </template>
      <template v-slot:item.tutor_invoice_id="{ item }">
        <span class="table-complete-name">QSL_{{ item.tutor_invoice_id }}</span>
      </template>

      <template v-slot:item.status="{ item }">
        <span class="table-complete-status st-success" v-if="item.status == 2">{{
          tutor_Invoice_status_formatter(item.status)
        }}</span>
        <span class="table-complete-status st-error" v-else>{{ item.status }}</span>
      </template>

      <template v-slot:item.start_date="{ item }">
        <span v-html="formatDate(item.start_date)"></span>
      </template>

      <template v-slot:item.created_at="{ item }">
        <span v-html="formatDate(item.created_at)"></span>
      </template>

      <template v-slot:item.end_date="{ item }">
        <span v-html="formatDate(item.end_date)"></span>
      </template>

      <template v-slot:item.amount="{ item }">
        <span>£ {{ item.amount }}</span>
      </template>

      <template v-slot:item.tutor_invoice_status="{ item }">
        <span
          class="table-complete-status st-success"
          v-if="item.tutor_invoice_status === 'cleared'"
          >{{ item.tutor_invoice_status }}</span
        >
        <span class="table-complete-status st-error" v-else>{{
          item.tutor_invoice_status
        }}</span>
      </template>

      <template v-slot:item.action="{ item }">
        <router-link
          class="profile-link"
          active-class
          :exact="true"
          :to="{ name: 'EditTutorEarning', params: { id: item.tutor_invoice_id } }"
        >
          <v-icon color="success" v-if="perms.tutor_earn_edit">mdi-file-edit</v-icon>
        </router-link>
        <v-icon color="red" @click="deleteDialogEvent(item)" v-if="perms.tutor_earn_delete">mdi-delete</v-icon>
      </template>
    </v-data-table>
    <div class="pa-2 d-flex justify-end">
      <span class="pa-2">
        Total Invoices
        <span :style="{ color: this.$vuetify.theme.themes.light.primary }">{{
          count
        }}</span>
      </span>
      <v-spacer></v-spacer>
      <v-pagination circle v-model="page" :length="totalPages"></v-pagination>
    </div>
  </v-card>
</template>

<script>
import DeleteDialog from "./DeleteDialog";
import DataTableMixin from "../../mixins/dataTable";
import DeleteRow from "../../mixins/deleteRow";
import moment from "moment";

export default {
  name: "TutorEarningTable",
  mixins: [DataTableMixin, DeleteRow],
  components: {
    DeleteDialog,
  },
  props : {
    perms : String
  },
  data() {
    return {
      loading: true,
      delete_dialog: false,
      page: 1,
      totalPages: 1,
      pageCount: 3,
      itemsPerPage: 10,
      current_row_id: -1,
      headers: [
        // {text: "Srno.", sortable: true, value: "id"},
        {
          text: "Invoice Id",
          value: "tutor_invoice_id",
          sortable: true,
        },
        {
          text: "Tutor Name",
          value: "tutor.tutor_fname",
          sortable: true,
        },
        {
          text: "Total Hours",
          value: "total_hours",
          sortable: false,
        },
        {
          text: "Amount",
          value: "amount",
          sortable: false,
        },
        {
          text: "Start Date",
          value: "start_date",
          sortable: true,
        },
        {
          text: "End Date",
          value: "end_date",
          sortable: true,
        },
        {
          text: "Payment Date",
          value: "created_at",
          sortable: true,
        },
        {
          text: "Status",
          value: "tutor_invoice_status",
          sortable: true,
        },
        {
          text: "Action",
          value: "action",
          sortable: false,
        },
      ],
    };
  },
  methods: {
    formatDate(date) {
      return moment(date, "DD-MMM-YYYY", true).isValid()
        ? date
        : moment(date).format("DD-MM-YYYY");
    },
    deleteDialogEvent(item) {
      this.current_row_id = item.tutor_invoice_id;
      this.delete_dialog = true;
    },
    deleteInvoice() {
      this.deleteConfirmLoading = true;
      axios
        .delete(apiRoutes.accounts.invoices.tutors.delete + "/" + this.current_row_id)
        .then((reponse) => {
          this.getItems();
          this.deleteConfirmLoading = false;
          this.delete_dialog = false;
        })
        .catch((error) => {});
    },
    getZeroAddedNum(num) {
      return num.toString().padStart(2, "0");
    },
    getItems(month = null, year = null) {
      this.loading = true;
      axios
        .get(apiRoutes.accounts.invoices.tutors.url, {
          params: {
            ...this.formQueryParams(),
            month: month,
            year: year,
          },
        })
        .then((response) => {
          this.totalPages = Math.ceil(response.data.total / 10);
          this.formalizeTable(response.data);
          this.loading = false;
        });
    },
    searchByMonth(val) {
      this.getItems(val);
    },
    searchByYear(val) {
      this.getItems(null, val);
    },
  },
  mounted() {
    this.loading = false;
    this.getItems();
  },
};
</script>

<style lang="scss">
.v-data-table-header th span {
  font: 300 14px Gotham;
  font-family: "Gotham Narrow";
  color: #8898aa;
}

.table-complete {
  &-srno {
    font: 500 14px/13px Gotham;
    color: #172b4d;
  }

  &-name {
    display: block;
    font: 500 14px/13px Gotham;
    color: #6a158e;
  }

  &-status {
    font: 500 14px/13px Gotham;

    &.st-success {
      color: #129b11;
    }

    &.st-error {
      color: #e41b1bf7;
    }
  }
}
</style>
